import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a868217aef1c967469788c5f3a08104e7b from "./generated-6609fe70-2a53-40df-9b09-b338b0ca2724.json";

import af361d46f7d9f50c9d2012547c7c4defdb from "./generated-aa53ed64-b7f6-4165-bbdf-b12254fd4b76.json";

import a4517785d2473966a140aa687cc06ee33b from "./generated-5d56f6ba-60f2-4ece-b897-a4ac3ae518bb.json";

import aec4185ac2c7b137ba7e6e5ffa1708e80b from "./generated-8164ec7f-cfbb-48d6-89ab-0ecd158cdde0.json";

import acc6ad2f4e77b63d8813ab94a041c7ad8b from "./generated-8f5bb398-4cf0-4d0a-bca9-315686251882.json";

import ae0f9587de1dee5e355931a7ed536718cb from "./generated-14a1b4ad-b487-4c73-b479-8fb1142d20b8.json";

import a35fe7f5c7d7d26c7e946c95255dec777b from "./generated-8d02d974-09a6-4269-85a9-7bfea85e6f49.json";

import a64b98e1e09a4162b97cff3ef1b65b830b from "./generated-669121fc-fd1d-4bbe-9fcd-61e1ca400b90.json";

import ac271f1f830ca2faaa4e96f5113d7e393b from "./generated-b441cdf4-3ee9-4cf7-a7b7-e73302ceddfe.json";

import ae03bef93b16083d97648b3b87d8877e4b from "./generated-0253f8ed-cf15-4c73-913d-301c75e81dd5.json";

import a268b9f0aba16f3b4491b38718599b227b from "./generated-3f278633-5b10-446d-b7bb-c2a7f3aad052.json";

import ad6f02880e13edafb3434214bd541bd5fb from "./generated-c0ebb1eb-934b-4d96-9a97-f6a098a78f98.json";

import a739d31f32d7720dfe758ed6d8c16eddcb from "./generated-194db41f-3c9f-4647-bd5e-5826cbafe876.json";

import a3bc51fb7b4aea6df09af4e0234b310aab from "./generated-c9d77d33-a8f2-449b-8ff3-00b7055bf0ba.json";

import a65b2686685ad90acde8dd9cb745b81c4b from "./generated-3aeef332-3c5a-4229-84fa-0e86bbc43e49.json";

import a866da42cf7297ad42a7c186114f49705b from "./generated-5058e6e6-c902-4ee1-84d8-5f2e0f6e6b93.json";

import a77b6d693c8501151d26fc343ed48b71fb from "./generated-c9ffdef8-66b7-42eb-9232-3d34c40c720e.json";

import a0e1ad326115ad2f405e321436cb93fd7b from "./generated-e1032d82-a1f9-4ed7-b7b6-44aacf7a549b.json";

import ab9dc233c1dd69095eddeb9192ec73165b from "./generated-0e7033b8-a5cb-4e81-b324-e9b496c8c952.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a868217aef1c967469788c5f3a08104e7b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(af361d46f7d9f50c9d2012547c7c4defdb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a4517785d2473966a140aa687cc06ee33b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(aec4185ac2c7b137ba7e6e5ffa1708e80b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(acc6ad2f4e77b63d8813ab94a041c7ad8b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(ae0f9587de1dee5e355931a7ed536718cb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a35fe7f5c7d7d26c7e946c95255dec777b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a64b98e1e09a4162b97cff3ef1b65b830b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(ac271f1f830ca2faaa4e96f5113d7e393b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(ae03bef93b16083d97648b3b87d8877e4b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a268b9f0aba16f3b4491b38718599b227b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(ad6f02880e13edafb3434214bd541bd5fb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a739d31f32d7720dfe758ed6d8c16eddcb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a3bc51fb7b4aea6df09af4e0234b310aab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a65b2686685ad90acde8dd9cb745b81c4b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a866da42cf7297ad42a7c186114f49705b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a77b6d693c8501151d26fc343ed48b71fb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a0e1ad326115ad2f405e321436cb93fd7b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(ab9dc233c1dd69095eddeb9192ec73165b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a77b6d693c8501151d26fc343ed48b71fb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */